import { DestroyRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Pipe({
  name: 'localeTranslation',
})
export class LocaleTranslationPipe implements PipeTransform, OnDestroy {
  private static defaultBackendLocale = 'en';
  private currentLocale!: BehaviorSubject<string>;

  // Angular pipes are component scoped.
  // Due to this we create one upstream subscription for locale changes, like we would do e.g. in a single component during the on init lifecycle.
  constructor(
    private readonly translocoService: TranslocoService,
    private readonly destroyRef: DestroyRef
  ) {
    this.currentLocale = new BehaviorSubject<string>(translocoService.getActiveLang());
    this.translocoService.langChanges$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: locale => {
        this.currentLocale.next(locale);
      },
    });
  }

  transform(translations: { [p: string]: string }): Observable<string> {
    return this.currentLocale.pipe(
      map(l => {
        const locale = this.getBackendLocaleForCurrentActiveLocale(l);
        const translation = translations[locale || LocaleTranslationPipe.defaultBackendLocale];
        return translation ? translation : '';
      })
    );
  }

  getBackendLocaleForCurrentActiveLocale(locale: string): string | undefined {
    if (locale === 'de-de') {
      return 'de';
    }
    if (locale === 'en-gb') {
      return 'en';
    }
    return undefined;
  }

  ngOnDestroy(): void {
    this.currentLocale.complete();
  }
}
